// extracted by mini-css-extract-plugin
export default {"testimonial":"testimonial_testimonial__wG8lk","quote":"testimonial_quote__kBM3C","byline":"testimonial_byline__IoejR"};